<template>
  <teleport to="body">
    <Transition name="auth-overlay">
      <div
        v-if="visible"
        class="auth-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="auth-overlay-title"
        @click.self="handleClose"
      >
        <div class="auth-card">

          <div class="auth-glow auth-glow-left"></div>
          <div class="auth-glow auth-glow-right"></div>

          <button
            type="button"
            class="auth-close"
            aria-label="Закрыть"
            @click="handleClose"
          >
            <svg
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M5.5 5.5L14.5 14.5M14.5 5.5L5.5 14.5"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />
            </svg>
          </button>

          <div class="auth-logo-zone">
            <div class="auth-logo-glow"></div>

            <img
              :src="logoLight"
              alt="HR3"
              class="auth-logo auth-logo-light"
            />

            <img
              :src="logoDark"
              alt="HR3"
              class="auth-logo auth-logo-dark"
            />
          </div>

          <div class="auth-status">
            <span class="auth-status-dot"></span>
            Требуется авторизация
          </div>

          <div class="auth-copy">
            <h2
              id="auth-overlay-title"
              class="auth-title"
            >
              Продолжите в HR3
            </h2>

            <p class="auth-description">
              Войдите в аккаунт или создайте новый,
              чтобы откликаться на вакансии и использовать
              все возможности платформы.
            </p>
          </div>

          <div class="auth-actions">

            <button
              type="button"
              class="auth-login-button"
              @click="$emit('login')"
            >
              <span>Войти</span>

              <svg
                viewBox="0 0 20 20"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M4 10H14"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                />
                <path
                  d="M10.5 6.5L14 10L10.5 13.5"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <button
              type="button"
              class="auth-register-button"
              @click="$emit('login')"
            >
              Создать аккаунт
            </button>

          </div>

          <div class="auth-bottom-note">
            Бесплатная регистрация
          </div>

        </div>
      </div>
    </Transition>
  </teleport>
</template>

<script setup>

import logoDark from "../assets/login_logo_dark.png";
import logoLight from "../assets/login_logo_light.png";

defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([
  "close",
  "login",
  "register"
]);

function handleClose() {
  emit("login");
}

</script>

<style scoped>

/* ============================================================
   OVERLAY
============================================================ */

.auth-overlay {
  position: fixed;
  inset: 0;
  z-index: 5000;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  padding: 24px;

  background:
    rgba(12, 15, 21, .58);

  backdrop-filter: blur(11px);
  -webkit-backdrop-filter: blur(11px);
}


/* ============================================================
   CARD
============================================================ */

.auth-card {
  position: relative;

  width: min(100%, 430px);

  overflow: hidden;

  box-sizing: border-box;

  padding:
    34px
    32px
    28px;

  background:
    linear-gradient(
      145deg,
      rgba(255,255,255,.99),
      rgba(248,250,253,.99)
    );

  border:
    1px solid
    rgba(40, 65, 105, .08);

  border-radius: 28px;

  box-shadow:
    0 32px 90px rgba(15, 28, 50, .25),
    0 1px 0 rgba(255,255,255,.75) inset;
}


/* ============================================================
   BACKGROUND GLOWS
============================================================ */

.auth-glow {
  position: absolute;
  pointer-events: none;
  border-radius: 50%;
  filter: blur(30px);
}

.auth-glow-left {
  top: -160px;
  left: -120px;

  width: 300px;
  height: 300px;

  background:
    rgba(52, 127, 231, .16);
}

.auth-glow-right {
  right: -150px;
  bottom: -190px;

  width: 330px;
  height: 330px;

  background:
    rgba(107, 87, 224, .12);
}


/* ============================================================
   CLOSE
============================================================ */

.auth-close {
  position: absolute;
  top: 16px;
  right: 16px;

  z-index: 10;

  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  color: #7b828d;

  background:
    rgba(255, 255, 255, .65);

  border:
    1px solid
    rgba(35, 45, 65, .06);

  border-radius: 12px;

  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  cursor: pointer;

  transition:
    transform .18s ease,
    background-color .18s ease,
    color .18s ease;
}

.auth-close:hover {
  color: #4b525c;
  background: #ffffff;

  transform:
    scale(1.05);
}

.auth-close svg {
  width: 16px;
  height: 16px;
}


/* ============================================================
   LOGO HERO
============================================================ */

.auth-logo-zone {
  position: relative;

  min-height: 150px;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 8px;
}

.auth-logo-glow {
  position: absolute;

  width: 220px;
  height: 110px;

  background:
    radial-gradient(
      circle,
      rgba(52, 127, 231, .13),
      transparent 70%
    );

  filter: blur(12px);

  pointer-events: none;
}

.auth-logo {
  position: relative;

  z-index: 2;

  display: block;

  width: auto;

  max-width: 330px;
  max-height: 125px;

  object-fit: contain;

  filter:
    drop-shadow(
      0 12px 22px
      rgba(30, 75, 140, .10)
    );
}

.auth-logo-dark {
  display: none;
}


/* ============================================================
   STATUS
============================================================ */

.auth-status {
  position: relative;
  z-index: 2;

  width: fit-content;

  min-height: 28px;

  display: flex;
  align-items: center;

  gap: 7px;

  margin:
    -2px
    auto
    0;

  padding:
    0
    11px;

  color: #6880a2;

  background:
    rgba(52, 127, 231, .065);

  border:
    1px solid
    rgba(52, 127, 231, .09);

  border-radius: 999px;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 9px;

  letter-spacing: .02em;
}

.auth-status-dot {
  width: 6px;
  height: 6px;

  background: #4b8dea;

  border-radius: 50%;

  box-shadow:
    0 0 0 4px
    rgba(75, 141, 234, .10);
}


/* ============================================================
   COPY
============================================================ */

.auth-copy {
  position: relative;
  z-index: 2;

  margin-top: 18px;

  text-align: center;
}

.auth-title {
  margin: 0;

  color: #292e36;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size: 24px;

  line-height: 1.18;

  letter-spacing: -.55px;
}

.auth-description {
  max-width: 335px;

  margin:
    11px
    auto
    0;

  color: #7e858f;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size: 11px;

  line-height: 1.6;
}


/* ============================================================
   ACTIONS
============================================================ */

.auth-actions {
  position: relative;
  z-index: 2;

  display: grid;

  grid-template-columns:
    1fr
    1fr;

  gap: 10px;

  margin-top: 27px;
}

.auth-login-button,
.auth-register-button {
  height: 48px;

  box-sizing: border-box;

  border-radius: 14px;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 11px;

  cursor: pointer;

  transition:
    transform .18s ease,
    box-shadow .18s ease,
    background-color .18s ease,
    border-color .18s ease;
}


/* ============================================================
   LOGIN
============================================================ */

.auth-login-button {
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 7px;

  color: #ffffff;

  background:
    linear-gradient(
      135deg,
      #3a8cf0 0%,
      #347fe7 50%,
      #496ee0 100%
    );

  border: none;

  box-shadow:
    0 10px 22px
    rgba(52, 127, 231, .24);
}

.auth-login-button svg {
  width: 17px;
  height: 17px;

  transition:
    transform .18s ease;
}

.auth-login-button:hover {
  transform:
    translateY(-2px);

  box-shadow:
    0 14px 28px
    rgba(52, 127, 231, .31);
}

.auth-login-button:hover svg {
  transform:
    translateX(2px);
}


/* ============================================================
   REGISTER
============================================================ */

.auth-register-button {
  color: #515965;

  background:
    rgba(255, 255, 255, .60);

  border:
    1px solid
    rgba(45, 65, 95, .10);

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.auth-register-button:hover {
  color: #343a42;

  background: #ffffff;

  border-color:
    rgba(52, 127, 231, .16);

  transform:
    translateY(-2px);

  box-shadow:
    0 9px 20px
    rgba(30, 55, 90, .07);
}


/* ============================================================
   BOTTOM NOTE
============================================================ */

.auth-bottom-note {
  position: relative;
  z-index: 2;

  margin-top: 14px;

  color: #a0a6ae;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size: 8px;

  text-align: center;
}


/* ============================================================
   DARK
============================================================ */

:global(html[data-theme="dark"])
.auth-card {
  background:
    radial-gradient(
      circle at 50% -15%,
      rgba(64, 130, 230, .13),
      transparent 35%
    ),
    linear-gradient(
      145deg,
      #22242a,
      #1d1f24
    );

  border-color:
    rgba(255,255,255,.07);

  box-shadow:
    0 34px 90px
    rgba(0,0,0,.48),
    0 1px 0
    rgba(255,255,255,.035)
    inset;
}

:global(html[data-theme="dark"])
.auth-close {
  color: #a0a5ae;

  background:
    rgba(255,255,255,.045);

  border-color:
    rgba(255,255,255,.055);
}

:global(html[data-theme="dark"])
.auth-close:hover {
  color: #ffffff;

  background:
    rgba(255,255,255,.075);
}

:global(html[data-theme="dark"])
.auth-logo-light {
  display: none;
}

:global(html[data-theme="dark"])
.auth-logo-dark {
  display: block;
}

:global(html[data-theme="dark"])
.auth-logo-glow {
  background:
    radial-gradient(
      circle,
      rgba(78, 145, 240, .15),
      transparent 70%
    );
}

:global(html[data-theme="dark"])
.auth-status {
  color: #91b6ee;

  background:
    rgba(91, 158, 255, .065);

  border-color:
    rgba(91, 158, 255, .09);
}

:global(html[data-theme="dark"])
.auth-status-dot {
  background: #77adf4;

  box-shadow:
    0 0 0 4px
    rgba(119, 173, 244, .09);
}

:global(html[data-theme="dark"])
.auth-title {
  color: #f0f1f3;
}

:global(html[data-theme="dark"])
.auth-description {
  color: #858a93;
}

:global(html[data-theme="dark"])
.auth-register-button {
  color: #c4c8cf;

  background:
    rgba(255,255,255,.035);

  border-color:
    rgba(255,255,255,.075);
}

:global(html[data-theme="dark"])
.auth-register-button:hover {
  color: #f0f1f3;

  background:
    rgba(255,255,255,.06);

  border-color:
    rgba(145,182,238,.14);

  box-shadow:
    0 10px 22px
    rgba(0,0,0,.18);
}

:global(html[data-theme="dark"])
.auth-bottom-note {
  color: #676d76;
}


/* ============================================================
   TRANSITION
============================================================ */

.auth-overlay-enter-active,
.auth-overlay-leave-active {
  transition:
    opacity
    .24s
    ease;
}

.auth-overlay-enter-active
.auth-card,
.auth-overlay-leave-active
.auth-card {
  transition:
    opacity
    .24s
    ease,
    transform
    .34s
    cubic-bezier(.22, 1, .36, 1);
}

.auth-overlay-enter-from,
.auth-overlay-leave-to {
  opacity: 0;
}

.auth-overlay-enter-from
.auth-card {
  opacity: 0;

  transform:
    translateY(14px)
    scale(.955);
}

.auth-overlay-leave-to
.auth-card {
  opacity: 0;

  transform:
    translateY(7px)
    scale(.98);
}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 520px) {

  .auth-overlay {
    align-items: flex-end;

    padding: 10px;
  }

  .auth-card {
    width: 100%;

    padding:
      28px
      20px
      22px;

    border-radius:
      25px;
  }

  .auth-logo-zone {
    min-height: 120px;
  }

  .auth-logo {
    max-width: 260px;
    max-height: 95px;
  }

  .auth-title {
    font-size: 21px;
  }

  .auth-description {
    font-size: 10px;
  }

  .auth-actions {
    grid-template-columns: 1fr;
  }

  .auth-login-button,
  .auth-register-button {
    height: 48px;
  }

}


/* ============================================================
   REDUCED MOTION
============================================================ */

@media (prefers-reduced-motion: reduce) {

  .auth-overlay-enter-active,
  .auth-overlay-leave-active,
  .auth-overlay-enter-active .auth-card,
  .auth-overlay-leave-active .auth-card,
  .auth-login-button,
  .auth-register-button,
  .auth-close {
    transition: none;
  }

}

</style>